let world_country_codes = [
 //A countries
 {country: "Afghanistan", alpha_2: "AF", alpha_3: "AFG", u_n_code: "004"},
 {country: "ALA	Aland Islands", alpha_2: "AX", alpha3: "ALA", u_n_code: "248"},
 {country: "Albania", alpha_2: "AL", alpha_3: "ALB", u_n_code: "008"},
 {country: "Algeria", alpha_2: "DZ", alpha_3: "DZA", u_n_code: "012"},
 {country: "American Samoa", alpha_2: "AS", alpha3: "ASM", u_n_code: "016"},
 {country: "Andorra", alpha_2: "AD", alpha_3: "AND", u_n_code: "020"},
 {country: "Angola", alpha_2: "AO", alpha_3: "AGO", u_n_code: "024"},
 {country: "Anguilla", alpha_2: "AI", alpha_3: "AIA", u_n_code: "660"},
 {country: "Antarctica", alpha_2: "AQ", alpha_3: "ATA", u_n_code: "010"},
 {country: "Antigua and Barbuda", alpha_2: "AG", alpha3: "ATG", u_n_code: "028"},
 {country: "Argentina", alpha_2: "AR", alpha_3: "ARG", u_n_code: "032"},
 {country: "Armenia", alpha_2: "AM", alpha_3: "ARM", u_n_code: "051"},
 {country: "Aruba", alpha_2: "AW", alpha_3: "ABW", u_n_code: "533"},
 {country: "Australia", alpha_2: "AU", alpha_3: "AUS", u_n_code: "036"},
 {country: "Austria", alpha_2: "AT", alpha_3: "AUT", u_n_code: "040"},
 {country: "Azerbaijan", alpha_2: "AZ", alpha_3: "AZE", u_n_code: "031"},
       
 //B countries
 {country: "Bahamas", alpha_2: "BS", alpha_3: "BHS", u_n_code: "044"},
 {country: "Bahrain", alpha_2: "BH", alpha_3: "BHR", u_n_code: "048"},
 {country: "Bangladesh", alpha_2: "BD", alpha_3: "BGD", u_n_code: "050"},
 {country: "Barbados", alpha_2: "BB", alpha_3: "BRB", u_n_code: "052"},
 {country: "Belarus", alpha_2: "BY", alpha_3: "BLR", u_n_code: "112"},
 {country: "Belgium", alpha_2: "BE", alpha_3: "BEL", u_n_code: "056"},
 {country: "Belize", alpha_2: "BZ", alpha_3: "BLZ", u_n_code: "084"},
 {country: "Benin", alpha_2: "BJ", alpha_3: "BEN", u_n_code: "204"},
 {country: "Bermuda", alpha_2: "BM", alpha_3: "BMU", u_n_code: "060"},
 {country: "Bhutan", alpha_2: "BT", alpha_3: "BTN", u_n_code: "064"},
 {country: "Bolivia", alpha_2: "BO", alpha_3: "BOL", u_n_code: "068"},
 {country: "Bosnia and Herzegovina", alpha_2: "BA", alpha_3: "BIH", u_n_code: "070"},
 {country: "Botswana", alpha_2: "BW", alpha_3: "BWA", u_n_code: "072"},
 {country: "Bouvet Island", alpha_2: "BV", alpha_3: "BVT", u_n_code: "074"},
 {country: "Brazil", alpha_2: "BR", alpha_3: "BRA", u_n_code: "076"},
 {country: "British Virgin Islands", alpha_2: "VG", alpha_3: "VGB", u_n_code: "092"},
 {country: "British Indian Ocean Territory", alpha_2: "IO", alpha_3: "IOT", u_n_code: "086"},
 {country: "Brunei Darussalam", alpha_2: "BN", alpha_3: "BRN", u_n_code: "096"},
 {country: "Bulgaria", alpha_2: "BG", alpha_3: "BGR", u_n_code: "100"},
 {country: "Burkina Faso", alpha_2: "BF", alpha_3: "BFA", u_n_code: "854"},
 {country: "Burundi", alpha_2: "BI", alpha_3: "BDI", u_n_code: "108"},
      
 //C countries
 {country: "Cambodia", alpha_2: "KH", alpha_3: "KHM", u_n_code: "116"},
 {country: "Cameroon", alpha_2: "CM", alpha_3: "CMR", u_n_code: "120"},
 {country: "Canada", alpha_2: "CA", alpha_3: "CAN", u_n_code: "124"},
 {country: "Cape Verde", alpha_2: "CV", alpha_3: "CPV", u_n_code: "132"},
 {country: "Cayman Islands", alpha_2: "KY", alpha_3: "CYM", u_n_code: "136"},
 {country: "Central African Republic", alpha_2: "CF", alpha_3: "CAF", u_n_code: "140"},
 {country: "Chad", alpha_2: "TD", alpha_3: "TCD", u_n_code: "148"},
 {country: "Chile", alpha_2: "CL", alpha_3: "CHL", u_n_code: "152"},
 {country: "China", alpha_2: "CN", alpha_3: "CHN", u_n_code: "156"},
 {country: "Hong Kong, SAR China", alpha_2: "HK", alpha_3: "HKG", u_n_code: "344"},
 {country: "Macao, SAR China", alpha_2: "MO", alpha_3: "MAC", u_n_code: "446"},
 {country: "Christmas Island", alpha_2: "CX", alpha_3: "CXR", u_n_code: "162"},
 {country: "Cocos (Keeling) Islands", alpha_2: "CC", alpha_3: "CCK", u_n_code: "166"},
 {country: "Colombia", alpha_2: "CO", alpha_3: "COL", u_n_code: "170"},
 {country: "Comoros", alpha_2: "KM", alpha_3: "COM", u_n_code: "174"},
 {country: "Congo (Brazzaville)", alpha_2: "CG", alpha_3: "COG", u_n_code: "178"},
 {country: "Congo, (Kinshasa)", alpha_2: "CD", alpha_3: "COD", u_n_code: "180"},
 {country: "Cook Islands", alpha_2: "CK", alpha_3: "COK", u_n_code: "184"},
 {country: "Costa Rica", alpha_2: "CR", alpha_3: "CRI", u_n_code: "188"},
 {country: "Côte d'Ivoire", alpha_2: "CI", alpha_3: "CIV", u_n_code: "384"},
 {country: "Croatia", alpha_2: "HR", alpha_3: "HRV", u_n_code: "191"},
 {country: "Cuba", alpha_2: "CU", alpha_3: "CUB", u_n_code: "192"},
 {country: "Cyprus", alpha_2: "CY", alpha_3: "CYP", u_n_code: "196"},
 {country: "Czech Republic", alpha_2: "CZ", alpha_3: "CZE", u_n_code: "203"},
         
 //D countries
 {country: "Denmark", alpha_2: "DK", alpha_3: "DNK", u_n_code: "208"},
 {country: "Djibouti", alpha_2: "DJ", alpha_3: "DJI", u_n_code: "262"},
 {country: "Dominica", alpha_2: "DM", alpha_3: "DMA", u_n_code: "212"},
 {country: "Dominican Republic", alpha_2: "DO", alpha_3: "DOM", u_n_code: "214"},
        
 //E countries
 {country: "Ecuador", alpha_2: "EC", alpha_3: "ECU", u_n_code: "218"},
 {country: "Egypt", alpha_2: "EG", alpha_3: "EGY", u_n_code: "818"},
 {country: "El Salvador", alpha_2: "SV", alpha_3: "SLV", u_n_code: "222"},
 {country: "Equatorial Guinea", alpha_2: "GQ", alpha_3: "GNQ", u_n_code: "226"},
 {country: "Eritrea", alpha_2: "ER", alpha_3: "ERI", u_n_code: "232"},
 {country: "Estonia", alpha_2: "EE", alpha_3: "EST", u_n_code: "233"},
 {country: "Ethiopia", alpha_2: "ET", alpha_3: "ETH", u_n_code: "231"},
      
 //F countries
 {country: "Falkland Islands (Malvinas)", alpha_2: "FK", alpha_3: "FLK", u_n_code: "238"},
 {country: "Faroe Islands", alpha_2: "FO", alpha_3: "FRO", u_n_code: "234"},
 {country: "Fiji", alpha_2: "FJ", alpha_3: "FJI", u_n_code: "242"},
 {country: "Finland", alpha_2: "FI", alpha_3: "FIN", u_n_code: "246"},
 {country: "France", alpha_2: "FR", alpha_3: "FRA", u_n_code: "250"},
 {country: "French Guiana", alpha_2: "GF", alpha_3: "GUF", u_n_code: "254"},
 {country: "French Polynesia", alpha_2: "PF", alpha_3: "PYF", u_n_code: "258"},
 {country: "French Southern Territories", alpha_2: "TF", alpha_3: "ATF", u_n_code: "260"},
         
 //G countries
 {country: "Gabon", alpha_2: "GA", alpha_3: "GAB", u_n_code: "266"},
 {country: "Gambia", alpha_2: "GM", alpha_3: "GMB", u_n_code: "270"},
 {country: "Georgia", alpha_2: "GE", alpha_3: "GEO", u_n_code: "268"},
 {country: "Germany", alpha_2: "DE", alpha_3: "DEU", u_n_code: "276"},
 {country: "Ghana", alpha_2: "GH", alpha_3: "GHA", u_n_code: "288"},
 {country: "Gibraltar", alpha_2: "GI", alpha_3: "GIB", u_n_code: "292"},
 {country: "Greece", alpha_2: "GR", alpha_3: "GRC", u_n_code: "300"},
 {country: "Greenland", alpha_2: "GL", alpha_3: "GRL", u_n_code: "304"},
 {country: "Grenada", alpha_2: "GD", alpha_3: "GRD", u_n_code: "308"},
 {country: "Guadeloupe", alpha_2: "GP", alpha_3: "GLP", u_n_code: "312"},
 {country: "Guam", alpha_2: "GU", alpha_3: "GUM", u_n_code: "316"},
 {country: "Guatemala", alpha_2: "GT", alpha_3: "GTM", u_n_code: "320"},
 {country: "Guernsey", alpha_2: "GG", alpha_3: "GGY", u_n_code: "831"},
 {country: "Guinea", alpha_2: "GN", alpha_3: "GIN", u_n_code: "324"},
 {country: "Guinea-Bissau", alpha_2: "GW", alpha_3: "GNB", u_n_code: "624"},
 {country: "Guyana", alpha_2: "GY", alpha_3: "GUY", u_n_code: "328"},
       
 //H countries
 {country: "Haiti", alpha_2: "HT", alpha_3: "HTI", u_n_code: "332"},
 {country: "Heard and Mcdonald Islands", alpha_2: "HM", alpha_3: "HMD", u_n_code: "334"},
 {country: "Holy See (Vatican City State)", alpha_2: "VA", alpha_3: "VAT", u_n_code: "336"},
 {country: "Honduras", alpha_2: "HN", alpha_3: "HND", u_n_code: "340"},
 {country: "Hungary", alpha_2: "HU", alpha_3: "HUN", u_n_code: "348"},
      
 //I countries
 {country: "Iceland", alpha_2: "IS", alpha_3: "ISL", u_n_code: "352"},
 {country: "India", alpha_2: "IN", alpha_3: "IND", u_n_code: "356"},
 {country: "Indonesia", alpha_2: "ID", alpha_3: "IDN", u_n_code: "360"},
 {country: "Iran, Islamic Republic of", alpha_2: "IR", alpha_3: "IRN", u_n_code: "364"},
 {country: "Iraq", alpha_2: "IQ", alpha_3: "IRQ", u_n_code: "368"},
 {country: "Ireland", alpha_2: "IE", alpha_3: "IRL", u_n_code: "372"},
 {country: "Isle of Man", alpha_2: "IM", alpha_3: "IMN", u_n_code: "833"},
 {country: "Israel", alpha_2: "IL", alpha_3: "ISR", u_n_code: "376"},
 {country: "Italy", alpha_2: "IT", alpha_3: "ITA", u_n_code: "380"},
      
 //J countries
 {country: "Jamaica", alpha_2: "JM", alpha_3: "JAM", u_n_code: "388"},
 {country: "Japan", alpha_2: "JP", alpha_3: "JPN", u_n_code: "392"},
 {country: "Jersey", alpha_2: "JE", alpha_3: "JEY", u_n_code: "832"},
 {country: "Jordan", alpha_2: "JO", alpha_3: "JOR", u_n_code: "400"},
           
 //K countries
 {country: "Kazakhstan", alpha_2: "KZ", alpha_3: "KAZ", u_n_code: "398"},
 {country: "Kenya", alpha_2: "KE", alpha_3: "KEN", u_n_code: "404"},
 {country: "Kiribati", alpha_2: "KI", alpha_3: "KIR", u_n_code: "296"},
 {country: "Korea (North)", alpha_2: "KP", alpha_3: "PRK", u_n_code: "408"},
 {country: "Korea (South)", alpha_2: "KR", alpha_3: "KOR", u_n_code: "410"},
 {country: "Kuwait", alpha_2: "KW", alpha_3: "KWT", u_n_code: "414"},
 {country: "Kyrgyzstan", alpha_2: "KG", alpha_3: "KGZ", u_n_code: "417"},
      
 //L countries
 {country: "Lao PDR", alpha_2: "LA", alpha_3: "LAO", u_n_code: "418"},
 {country: "Latvia", alpha_2: "LV", alpha_3: "LVA", u_n_code: "428"},
 {country: "Lebanon", alpha_2: "LB", alpha_3: "LBN", u_n_code: "422"},
 {country: "Lesotho", alpha_2: "LS", alpha_3: "LSO", u_n_code: "426"},
 {country: "Liberia", alpha_2: "LR", alpha_3: "LBR", u_n_code: "430"},
 {country: "Libya", alpha_2: "LY", alpha_3: "LBY", u_n_code: "434"},
 {country: "Liechtenstein", alpha_2: "LI", alpha_3: "LIE", u_n_code: "438"},
 {country: "Lithuania", alpha_2: "LT", alpha_3: "LTU", u_n_code: "440"},
 {country: "Luxembourg", alpha_2: "LU", alpha_3: "LUX", u_n_code: "442"},
      
 //M countries
 {country: "Macedonia", alpha_2: "MK", alpha_3: "MKD", u_n_code: "807"},
 {country: "Madagascar", alpha_2: "MG", alpha_3: "MDG", u_n_code: "450"},
 {country: "Malawi", alpha_2: "MW", alpha_3: "MWI", u_n_code: "454"},
 {country: "Malaysia", alpha_2: "MY", alpha_3: "MYS", u_n_code: "458"},
 {country: "Maldives", alpha_2: "MV", alpha_3: "MDV", u_n_code: "462"},
 {country: "Mali", alpha_2: "ML", alpha_3: "MLI", u_n_code: "466"},
 {country: "Malta", alpha_2: "MT", alpha_3: "MLT", u_n_code: "470"},
 {country: "Marshall Islands", alpha_2: "MH", alpha_3: "MHL", u_n_code: "584"},
 {country: "Martinique", alpha_2: "MQ", alpha_3: "MTQ", u_n_code: "474"},
 {country: "Mauritania", alpha_2: "MR", alpha_3: "MRT", u_n_code: "478"},
 {country: "Mauritius", alpha_2: "MU", alpha_3: "MUS", u_n_code: "480"},
 {country: "Mayotte", alpha_2: "YT", alpha_3: "MYT", u_n_code: "175"},
 {country: "Mexico", alpha_2: "MX", alpha_3: "MEX", u_n_code: "484"},
 {country: "Micronesia", alpha_2: "FM", alpha_3: "FSM", u_n_code: "583"},
 {country: "Moldova", alpha_2: "MD", alpha_3: "MDA", u_n_code: "498"},
 {country: "Monaco", alpha_2: "MC", alpha_3: "MCO", u_n_code: "492"},
 {country: "Mongolia", alpha_2: "MN", alpha_3: "MNG", u_n_code: "496"},
 {country: "Montenegro", alpha_2: "ME", alpha_3: "MNE", u_n_code: "499"},
 {country: "Montserrat", alpha_2: "MS", alpha_3: "MSR", u_n_code: "500"},
 {country: "Morocco", alpha_2: "MA", alpha_3: "MAR", u_n_code: "504"},
 {country: "Mozambique", alpha_2: "MZ", alpha_3: "MOZ", u_n_code: "508"},
 {country: "Myanmar", alpha_2: "MM", alpha_3: "MMR", u_n_code: "104"},
         
 //N countries
 {country: "Namibia", alpha_2: "NA", alpha_3: "NAM", u_n_code: "516"},
 {country: "Nauru", alpha_2: "NR", alpha_3: "NRU", u_n_code: "520"},
 {country: "Nepal", alpha_2: "NP", alpha_3: "NPL", u_n_code: "524"},
 {country: "Netherlands", alpha_2: "NL", alpha_3: "NLD", u_n_code: "528"},
 {country: "Netherlands Antilles", alpha_2: "AN", alpha_3: "ANT", u_n_code: "530"},
 {country: "New Caledonia", alpha_2: "NC", alpha_3: "NCL", u_n_code: "540"},
 {country: "New Zealand", alpha_2: "NZ", alpha_3: "NZL", u_n_code: "554"},
 {country: "Nicaragua", alpha_2: "NI", alpha_3: "NIC", u_n_code: "558"},
 {country: "Niger", alpha_2: "NE", alpha_3: "NER", u_n_code: "562"},
 {country: "Nigeria", alpha_2: "NG", alpha_3: "NGA", u_n_code: "566"},
 {country: "Niue", alpha_2: "NU", alpha_3: "NIU", u_n_code: "570"},
 {country: "Norfolk Island", alpha_2: "NF", alpha_3: "NFK", u_n_code: "574"},
 {country: "Northern Mariana Islands", alpha_2: "MP", alpha_3: "MNP", u_n_code: "580"},
 {country: "Norway", alpha_2: "NO", alpha_3: "NOR", u_n_code: "578"},
           
 //O countries
 {country: "Oman", alpha_2: "OM", alpha_3: "OMN", u_n_code: "512"},
      
 //P countries
 {country: "Pakistan", alpha_2: "PK", alpha_3: "PAK", u_n_code: "586"},
 {country: "Palau", alpha_2: "PW", alpha_3: "PLW", u_n_code: "585"},
 {country: "Palestinian Territory", alpha_2: "PS", alpha_3: "PSE", u_n_code: "275"},
 {country: "Panama", alpha_2: "PA", alpha_3: "PAN", u_n_code: "591"},
 {country: "Papua New Guinea", alpha_2: "PG", alpha_3: "PNG", u_n_code: "598"},
 {country: "Paraguay", alpha_2: "PY", alpha_3: "PRY", u_n_code: "600"},
 {country: "Peru", alpha_2: "PE", alpha_3: "PER", u_n_code: "604"},
 {country: "Philippines", alpha_2: "PH", alpha_3: "PHL", u_n_code: "608"},
 {country: "Pitcairn", alpha_2: "PN", alpha_3: "PCN", u_n_code: "612"},
 {country: "Poland", alpha_2: "PL", alpha_3: "POL", u_n_code: "616"},
 {country: "Portugal", alpha_2: "PT", alpha_3: "PRT", u_n_code: "620"},
 {country: "Puerto Rico", alpha_2: "PR", alpha_3: "PRI", u_n_code: "630"},
          
 //Q countries
 {country: "Qatar", alpha_2: "QA", alpha_3: "QAT", u_n_code: "634"},
      
 //R countries
 {country: "Réunion", alpha_2: "RE", alpha_3: "REU", u_n_code: "638"},
 {country: "Romania", alpha_2: "RO", alpha_3: "ROU", u_n_code: "642"},
 {country: "Russian Federation", alpha_2: "RU", alpha_3: "RUS", u_n_code: "643"},
 {country: "Rwanda", alpha_2: "RW", alpha_3: "RWA", u_n_code: "646"},
           
 //S countries
 {country: "Saint-Barthélemy", alpha_2: "BL", alpha_3: "BLM", u_n_code: "652"},
 {country: "Saint Helena", alpha_2: "SH", alpha_3: "SHN", u_n_code: "654"},
 {country: "Saint Kitts and Nevis", alpha_2: "KN", alpha_3: "KNA", u_n_code: "659"},
 {country: "Saint Lucia", alpha_2: "LC", alpha_3: "LCA", u_n_code: "662"},
 {country: "Saint-Martin (French part)", alpha_2: "MF", alpha_3: "MAF", u_n_code: "663"},
 {country: "Saint Pierre and Miquelon", alpha_2: "PM", alpha_3: "SPM", u_n_code: "666"},
 {country: "Saint Vincent and Grenadines", alpha_2: "VC", alpha_3: "VCT", u_n_code: "670"},
 {country: "Samoa", alpha_2: "WS", alpha_3: "WSM", u_n_code: "882"},
 {country: "San Marino", alpha_2: "SM", alpha_3: "SMR", u_n_code: "674"},
 {country: "Sao Tome and Principe", alpha_2: "ST", alpha_3: "STP", u_n_code: "678"},
 {country: "Saudi Arabia", alpha_2: "SA", alpha_3: "SAU", u_n_code: "682"},
 {country: "Senegal", alpha_2: "SN", alpha_3: "SEN", u_n_code: "686"},
 {country: "Serbia", alpha_2: "RS", alpha_3: "SRB", u_n_code: "688"},
 {country: "Seychelles", alpha_2: "SC", alpha_3: "SYC", u_n_code: "690"},
 {country: "Sierra Leone", alpha_2: "SL", alpha_3: "SLE", u_n_code: "694"},
 {country: "Singapore", alpha_2: "SG", alpha_3: "SGP", u_n_code: "702"},
 {country: "Slovakia", alpha_2: "SK", alpha_3: "SVK", u_n_code: "703"},
 {country: "Slovenia", alpha_2: "SI", alpha_3: "SVN", u_n_code: "705"},
 {country: "Solomon Islands", alpha_2: "SB", alpha_3: "SLB", u_n_code: "090"},
 {country: "Somalia", alpha_2: "SO", alpha_3: "SOM", u_n_code: "706"},
 {country: "South Africa", alpha_2: "ZA", alpha_3: "ZAF", u_n_code: "710"},
 {country: "South Georgia and the South Sandwich Islands", alpha_2: "GS", alpha_3: "SGS", u_n_code: "239"},
 {country: "South Sudan", alpha_2: "SS", alpha_3: "SSD", u_n_code: "728"},
 {country: "Spain", alpha_2: "ES", alpha_3: "ESP", u_n_code: "724"},
 {country: "Sri Lanka", alpha_2: "LK", alpha_3: "LKA", u_n_code: "144"},
 {country: "Sudan", alpha_2: "SD", alpha_3: "SDN", u_n_code: "736"},
 {country: "Suriname", alpha_2: "SR", alpha_3: "SUR", u_n_code: "740"},
 {country: "Svalbard and Jan Mayen Islands", alpha_2: "SJ", alpha_3: "SJM", u_n_code: "744"},
 {country: "Swaziland", alpha_2: "SZ", alpha_3: "SWZ", u_n_code: "748"},
 {country: "Sweden", alpha_2: "SE", alpha_3: "SWE", u_n_code: "752"},
 {country: "Switzerland", alpha_2: "CH", alpha_3: "CHE", u_n_code: "756"},
 {country: "Syrian Arab Republic (Syria)", alpha_2: "SY", alpha_3: "SYR", u_n_code: "760"},
          
 //T countries
 {country: "Taiwan, Republic of China", alpha_2: "TW", alpha_3: "TWN", u_n_code: "158"},
 {country: "Tajikistan", alpha_2: "TJ", alpha_3: "TJK", u_n_code: "762"},
 {country: "Tanzania, United Republic of", alpha_2: "TZ", alpha_3: "TZA", u_n_code: "834"},
 {country: "Thailand", alpha_2: "TH", alpha_3: "THA", u_n_code: "764"},
 {country: "Timor-Leste", alpha_2: "TL", alpha_3: "TLS", u_n_code: "626"},
 {country: "Togo", alpha_2: "TG", alpha_3: "TGO", u_n_code: "768"},
 {country: "Tokelau", alpha_2: "TK", alpha_3: "TKL", u_n_code: "772"},
 {country: "Tonga", alpha_2: "TO", alpha_3: "TON", u_n_code: "776"},
 {country: "Trinidad and Tobago", alpha_2: "TT", alpha_3: "TTO", u_n_code: "780"},
 {country: "Tunisia", alpha_2: "TN", alpha_3: "TUN", u_n_code: "788"},
 {country: "Turkey", alpha_2: "TR", alpha_3: "TUR", u_n_code: "792"},
 {country: "Turkmenistan", alpha_2: "TM", alpha_3: "TKM", u_n_code: "795"},
 {country: "Turks and Caicos Islands", alpha_2: "TC", alpha_3: "TCA", u_n_code: "796"},
 {country: "Tuvalu", alpha_2: "TV", alpha_3: "TUV", u_n_code: "798"},
          
 //U counties
 {country: "Uganda", alpha_2: "UG", alpha_3: "UGA", u_n_code: "800"},
 {country: "Ukraine", alpha_2: "UA", alpha_3: "UKR", u_n_code: "804"},
 {country: "United Arab Emirates", alpha_2: "AE", alpha_3: "ARE", u_n_code: "784"},
 {country: "United Kingdom", alpha_2: "GB", alpha_3: "GBR", u_n_code: "826"},
 {country: "United States", alpha_2: "US", alpha_3: "USA", u_n_code: "840"},
 {country: "US Minor Outlying Islands", alpha_2: "UM", alpha_3: "UMI", u_n_code: "581"},
 {country: "Uruguay", alpha_2: "UY", alpha_3: "URY", u_n_code: "858"},
 {country: "Uzbekistan", alpha_2: "UZ", alpha_3: "UZB", u_n_code: "860"},
           
 //V counties
 {country: "Vanuatu", alpha_2: "VU", alpha_3: "VUT", u_n_code: "548"},
 {country: "Venezuela (Bolivarian Republic)", alpha_2: "VE", alpha_3: "VEN", u_n_code: "862"},
 {country: "Viet Nam", alpha_2: "VN", alpha_3: "VNM", u_n_code: "704"},
 {country: "Virgin Islands, US", alpha_2: "VI", alpha_3: "VIR", u_n_code: "850"},
         
 //W counties
 {country: "Wallis and Futuna Islands", alpha_2: "WF", alpha_3: "WLF", u_n_code: "876"},
 {country: "Western Sahara", alpha_2: "EH", alpha_3: "ESH", u_n_code: "732"},
          
 //Y-Z counties
 {country: "Yemen", alpha_2: "YE", alpha_3: "YEM", u_n_code: "887"},
 {country: "Zambia", alpha_2: "ZM", alpha_3: "ZMB", u_n_code: "894"},
 {country: "Zimbabwe", alpha_2: "ZW", alpha_3: "ZWE", u_n_code: "716"},
];

export const return_country_from_code = (code) => {
    return world_country_codes.filter(each => {
        return (each.alpha_2 === code ||
                each.alpha3 === code ||
                each.u_n_code === code)
    });
}

export const bind_country_alpha_codes = (input_id, current=0, alpha=2) => {

    let select_input = document.getElementById(input_id);
    select_input.innerHTML = "";

    for(let i=0; i<world_country_codes.length; i++){

        if(world_country_codes[i].code === "")
            continue;

        select_input.innerHTML += `
            <option value="${(alpha===2) ? world_country_codes[i]?.alpha_2 : world_country_codes[i]?.alpha_3}">
            ${world_country_codes[i]?.country}</option>
        `;
    }

    if(current)
        select_input.value=current;

    return {done: true};

}

export const return_country_alpha_option_components = (current=0, alpha=2) => {

    let options=[];

    for(let i=0; i<world_country_codes.length; i++){
        options.push(
            <option value={(alpha===2) ? world_country_codes[i]?.alpha_2 : world_country_codes[i]?.alpha_3}>
                {world_country_codes[i]?.country}
            </option>
        );
    }

    return options;

}

